import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import '../public/follow';

import interceptorsSetup from "./helpers/interceptor";
import RateTab from '@/views/on_table/RateExpMenu/RateTab';

interceptorsSetup();
Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.component('RateTab', RateTab);
let locationHostmane = process.env.NODE_ENV === 'production' && (
  document.location.hostname.split('.')[0] === 'rayados-mty' ||
  document.location.hostname.split('.')[0] === 'cinemex-platino' ||
  document.location.hostname.split('.')[0] === 'clemente-cafe-y-flores'  ||
  document.location.hostname.split('.')[0] === 'floretto'  ||
  document.location.hostname.split('.')[0] === 'trapani-pizza-estofada'  ||
  document.location.hostname.split('.')[0] === 'hotel-hilton'  ||
  document.location.hostname.split('.')[0] === 'mosquito'  ||
  document.location.hostname.split('.')[0] === 'parrilla-express');
if (locationHostmane) {
  Sentry.init({
    Vue,
    environment: process.env.NODE_ENV,
    release: `${process.env.VUE_APP_NAME}@${process.env.VUE_APP_VERSION}`,
    dsn: process.env.VUE_APP_SENTRY,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['*.vue-pre-produccion.*', '*.menucluvi.*', '*.cluvi.*', /^\//],
      }),
    ],
    debug: process.env.NODE_ENV  !==  'production',
    tracesSampleRate: 0.1,
    tracesSampler: 0,
    sampleRate: 0.1,
    tracingOptions: {
      trackComponents: true,
    },
    // Vue specific
    logErrors: process.env.NODE_ENV === 'production' ? false : true,
    attachProps: true,
    attachStacktrace: true,
    maxBreadcrumbs: 0.5
  });
};

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
